import React from 'react';
import './sincompras.css';
import promoVW from './imgs/promociones_ico.svg';
import ButtonPrimary from '../../../componentes/cupra/controls/ButtonPrimary';
import headerCupra from '../../../App/imgs/cupra/cupra-header-compra.png';
import headerCupraMd from '../../../App/imgs/cupra/cupra-header-compra-md.png';
import headerCupraSm from '../../../App/imgs/cupra/cupra-header-compra-sm.png';

class SinCompras extends React.Component {

    componentDidMount() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarVistaVisitadaAnalitica("SinCompras");
        }
    }

    render() {
        return (
            <div className='min_h'>

                {
                    this.props.marca === "cupra" &&

                    <div className={"conteiner-header-cupra-visible"}>
                        <img className='d-none d-lg-block compra-img-header-cupra' src={headerCupra} alt="header_kmi_cupra" />
                        <img className='d-none d-md-block d-lg-none compra-img-header-cupra' src={headerCupraMd} alt="header_kmi_cupra" />
                        <img className='d-block d-md-none compra-img-header-cupra' src={headerCupraSm} alt="header_kmi_cupra" />
                    </div>
                }


                <div className="container">
                    <div className="col col-md-8 offset-md-2 mt-5">

                        {
                            this.props.marca !== "cupra" ?

                                <>
                                    <p className={"sincompras__label" + (this.props.marca === "seat" ? (" pasos__titulo--" + this.props.marca) : "")}><span className={"pasos__titulo--" + this.props.marca}>Aún no tienes</span> una GUÍA asignada.</p>
                                    <p className="sincompras__label--segunda mt-5">Te invitamos a conocer nuestras Promociones.</p>
                                </>

                                :

                                <div>
                                    <div className='pasos_text_container'>
                                        <p className={"sincompras__label"}><span className={"pasos__titulo--cupra"}>Aún no tienes una guía asignada.</span></p>
                                        <p className="sincompras__label--segunda pasos__titulo--cupra2  mt-4">Te invitamos a conocer nuestras promociones.</p>
                                    </div>
                                </div>

                        }


                    </div>
                    <div className="col col-md-8 offset-md-2 mt-3 mb-5">
                        <div className="row">
                            <div className="col-xs-12 col-lg-6 offset-lg-3 mt-3">
                                {
                                    this.props.marca === "audi" ?
                                        <button className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={() => { window.open('https://www.audi.com.mx/mx/web/es.html', '_blank') }}>Promociones Audi
                                            <svg className="sincompras__boton--audi ml-2" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.5 34.5L18.5 40.5 14.5 44.5 9.5 44.5 9 43.5 12 40.5 12 39.5 8.5 36 7.5 36 4.5 39 3.5 38.5 3.5 33.5 7.5 29.5 13.5 29.5 29.5 13.5 29.5 7.5 33.5 3.5 38.5 3.5 39 4.5 36 7.5 36 8.5 39.5 12 40.5 12 43.5 9 44.5 9.5 44.5 14.5 40.5 18.5 34.5 18.5z" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                            </svg>
                                        </button>

                                        :

                                        (
                                            this.props.marca === "vw" ? (
                                                <div className="row">
                                                    <div className="col col-md-12 offset-md-2 mt-2">
                                                        <button className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={() => { window.open('https://www.vw.com.mx/es.html', '_blank') }}>
                                                            <img src={promoVW} alt="Promociones" height="20" className="mr-2" />
                                                            Promociones VW pasajeros
                                                        </button>
                                                    </div>
                                                    <div className="col col-md-12 offset-md-2 mt-2">
                                                        <button className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={() => { window.open('https://www.vwcomerciales.com.mx/es/promociones-vehiculos.html', '_blank') }}>
                                                            <img src={promoVW} alt="Promociones" height="20" className="mr-2" />
                                                            Promociones VW Comerciales
                                                        </button>
                                                    </div>
                                                </div>
                                            )

                                                :

                                                (this.props.marca === "seat" ? (
                                                    <button className={"w-75 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={() => { window.open('https://www.seat.mx/', '_blank') }}>
                                                        Promociones SEAT
                                                    </button>
                                                )

                                                    :

                                                    <div className='p-5'>
                                                        <ButtonPrimary textButton={"Promociones CUPRA"} onClick={() => window.open('https://www.cupraoficial.mx/', '_blank')} styleirvehiculo={false}></ButtonPrimary>
                                                    </div>
                                                )
                                        )
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }

}

export default SinCompras;